import { Component, OnInit, Input, Output, EventEmitter, Injectable, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import {MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { SnotifyService, ToastDefaults } from 'ng-snotify';
import { StatisticsService } from 'src/app/statistics/statistics.service';
import { ToastrService } from 'ngx-toastr';
import { debounceTime } from 'rxjs';

@Component({
  selector: 'app-add-edit-roles',
  templateUrl: './add-edit-roles.component.html',
  styleUrls: ['./add-edit-roles.component.css'],
})

export class AddEditRolesComponent implements OnInit {
  @Input() data: any;
  @Output() added = new EventEmitter<any>();
  @ViewChild('rolesaccordion',{static:true}) rolesPanels: MatAccordion;

  role: any = {}
  levels: any[] = [];
  arrLevel: any;
  roleID: number
  roleInfo: any = {};
  roleName: string;
  roleType;
  clickButton: boolean = false
  panelOpenState = false;
  controllers: any[] = [];
  isActive: string = 'ui'
  rolesAccess: any;
  controlle: any[] = [];
  rolesList: any = []
  filterText = ""
  showddlrole = false
  type=1
  filterdOptions: any[] = []
  cultureArray: any[] = []
  cultureId=null
  allPages: any[] = []
  allTemplates: any[] = []
  pageId=null
  templateId=null
types=[{id:1,name:"Pages"},{id:2,name:"Templates"}]
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public statisticsService:StatisticsService ,
    private snotifyService: ToastrService,) {
      
  }

  ngOnInit() {

    this.roleID = +this.activatedRoute.snapshot.paramMap.get('id')
    if (this.roleID && this.roleID != 0) {
      this.getRoleById()
      this.GetRoleAccess()
    }
    else {
      this.getAllLevels();
    }
    this.GetRoles()
    this.getAllCulture();
    this.getAllTemplates();
  }
  getAllCulture() {



     this.httpClient.get(`/Sites/GetUsedSiteCulturesByStatus/${2}`).subscribe((res: any) => {
      this.cultureArray = res;})
  }
  getRoleById(roleID?) {
    var id = roleID ? +roleID : this.roleID
    this.httpClient.get(`/RolesManagement/GetRoleById/${id}`).subscribe((res: any) => {
      this.roleInfo.options = []
      this.roleInfo = res
      if (this.roleID) {
        this.roleName = res.role.name
        this.roleType = res.role.type
        this.getAllLevels()
      }

     
      if (this.roleInfo.options.length > 0) {
        this.roleInfo.options.forEach(eleOptins => {
          this.searchOption(eleOptins.optionId)
        });
      } else {
        this.getAllLevels()
      }



    })
  }
  public getAllPages(culture) {
   
     this.httpClient.get(`/Pages/GetAllPagesFlat/${0}/${0}/${2}/${culture}`).pipe(debounceTime(500)).subscribe((res:any)=>{
this.allPages = res;
     });
  }
  getAllTemplates(){
     this.httpClient.get(`/PageTemplate/GetAllPageTemplates`).pipe(debounceTime(500)).subscribe((res:any)=>{
this.allTemplates = res;
     });
  }
  GetRoles() {
    this.httpClient.get('/RolesManagement/GetRoles').subscribe((res: any) => {
      this.rolesList = res;

    });
  }

  getAllLevels() {
    //this.httpClient.get<any[]>('/RolesManagement/GetOptionsLevelsOfUserRole').subscribe((res: any) => {
    this.httpClient.get<any[]>('/RolesManagement/GetOptionsLevelsOfUserRole').subscribe((res: any) => {

      this.levels = res
      if (this.roleID && this.roleID != 0) {
        this.roleInfo.options.forEach(eleOptins => {
          this.searchOption(eleOptins.optionId)
        });
      }
      this.filterdOptions = this.levels

    });
  }

  searchOption(optionId) {
    this.levels.forEach(eleLevels => {
      eleLevels.optionsList.forEach(eleOptnListLvl => {
        if (eleOptnListLvl.id == optionId) {
          eleOptnListLvl.isChecked = true
          return true
        }
      });
      eleLevels.subLevelList.forEach(eleSubLvl => {
        eleSubLvl.optionsList.forEach(eleOptnLst => {
          if (eleOptnLst.id == optionId) {
            eleOptnLst.isChecked = true
            return true
          }
        });
      });
      return false;
    });
  }

  isSubLevelsEmpty(subLevels) {
    if (subLevels !== null && subLevels.length > 0) {
      for (let i = 0; i < subLevels.length; i++) {
        const subLevel = subLevels[i];
        if (subLevel.optionsList && subLevel.optionsList.length)
          return false
        else
          return true
      }
    }
    else
      return true

  }

  selectAll(level, e) {
    level.isOpend = true
    for (let i = 0; i < level.optionsList.length; i++) {
      const optnLst = level.optionsList[i];
      optnLst.isChecked = e.srcElement.checked;
    }
    if (level.subLevelList != null && level.subLevelList.length > 0)
      for (let i = 0; i < level.subLevelList.length; i++) {
        const subLvlLst = level.subLevelList[i];
        for (let i = 0; i < subLvlLst.optionsList.length; i++) {
          const suboptnLst = subLvlLst.optionsList[i];
          suboptnLst.isChecked = e.srcElement.checked;
        }
      }
  }

  filterOptions() {
    this.filterdOptions = JSON.parse(JSON.stringify(this.levels))

    if (this.filterText != "") {

      for (let i = 0; i < this.filterdOptions.length; i++) {
        const lvl = this.filterdOptions[i];
        for (let ii = 0; ii < lvl.optionsList.length; ii++) {
          const opt = lvl.optionsList[ii];
          if (opt.code.toUpperCase().indexOf(this.filterText.toUpperCase()) == -1 &&
            opt.name.toUpperCase().indexOf(this.filterText.toUpperCase()) == -1) {
            lvl.optionsList.splice(ii, 1)
            ii--
          }
        }

      }



    } else {
      (this.filterdOptions.length == 0)
      this.filterdOptions = this.levels
    }
  }


  isSelectedAll(level) {
    if (level.optionsList.length == 0 && level.subLevelList == null)
      return false;
    if (level.optionsList.length == 0 && level.subLevelList != null && level.subLevelList.length == 0)
      return false;

    for (let i = 0; i < level.optionsList.length; i++) {
      const lo = level.optionsList[i];
      if (lo.isChecked != true) {
        return false;
      }
      if (level.subLevelList != null && level.subLevelList.length > 0) {
        level.subLevelList.forEach(subL => {
          for (let i = 0; i < subL.optionsList.length; i++) {
            const subLO = subL.optionsList[i];
            if (subLO.isChecked != true) {
              return false;
            }
          }
        });
      }
    }
    return true;
  }




  GetRoleAccess() {
    this.httpClient.get(`/RolesManagement/GetRoleAccess/${this.roleID}`).subscribe((res: any) => {
      this.rolesAccess = res;
      if (this.rolesAccess && this.rolesAccess != null) {
        this.GetControllersInfo();
      }
    })
  }

  GetControllersInfo() {
    this.httpClient.get('/RolesManagement/GetControllersInfo').subscribe((res: any) => {
      this.controllers = res
      if (this.rolesAccess.controllers.length > 0) {
        this.rolesAccess.controllers.forEach(contr => {
          contr.actions.forEach(action => {
            this.searchAction(action.name, contr.id, action.id)
          });
        });
      }

    })
  }

  searchAction(controlName, Id, actionId) {
    for (let i = 0; i < this.controllers.length; i++) {
      const control = this.controllers[i];
      for (let ii = 0; ii < control.actions.length; ii++) {
        const action = control.actions[ii];
        action.controllerId = null
        Id != null ? control.id = Id : control.id = null
        actionId != null ? action.id = actionId : action.id = null
        if (action.name === controlName) {
          action.isChecked = true
          return true
        }
      }
      return false;
    }
  }


  selectAllController(contol, e) {

    for (let i = 0; i < contol.actions.length; i++) {
      const cntrl = contol.actions[i];
      cntrl.isChecked = e.srcElement.checked;
    }
    this.filterdOptions = this.levels
  }

  isSelectedAllController(contol) {

    for (let i = 0; i < contol.actions.length; i++) {
      const cntrl = contol.actions[i];
      if (cntrl.isChecked != true) {
        return false;
      }
    }
    return true;
  }

  saveRole(form) {

    if (form.invalid) {
      Object.keys(form.controls).forEach(feild => {
        form.controls[feild].markAsTouched(true);
      });
      return
    }
    let ListOfOptionsArr = []
    this.levels.forEach(element => {
      element.optionsList.forEach(ee => {
        if (ee.isChecked == true) {
          ListOfOptionsArr.push({ OptionId: ee.id })
        }
      });
      element.subLevelList.forEach(eee => {
        eee.optionsList.forEach(eeee => {
          if (eeee.isChecked == true) {
            ListOfOptionsArr.push({ OptionId: eeee.id })
          }
        });
      });
    });
    let listOfController = []
    let listOfAction = []
    this.controllers.forEach(contoller => {
      contoller.actions.forEach(action => {
        if (action.isChecked == true) {
          listOfAction.push({
            'Name': action.name, 'DisplayName': action.displayName, 'ControllerId': action.controllerId, 'isSelected': true, 'Id': action.id
          })
        }
        else {
          listOfAction.push({
            'Name': action.name, 'DisplayName': action.displayName, 'ControllerId': action.controllerId, 'isSelected': false, 'Id': action.id
          })
        }
        listOfController.push({
          'Name': contoller.name, 'DisplayName': contoller.displayName, 'AreaName': contoller.areaName, 'Id': contoller.id,
          'Actions': listOfAction
        })

      });
    });

    const data = {
      'RoleId': this.roleID ? this.roleID : 0,
      'RoleName': this.roleName,
      'ListOfOptions': ListOfOptionsArr,
      'roleType': this.roleType,
      'SelectedControllers':   [] 
    }
    if (this.roleID) {
      this.httpClient.post('/RolesManagement/EditRole', data)
      .subscribe(
        (res) => {
        this.openNotifySuccess("Modified Succefully");
        this.close()
      })
    } else {
      this.httpClient.post('/RolesManagement/AddRole', data).subscribe((res) => {
        this.openNotifySuccess("Added Successfully");
        this.close()
      })
    }
  }

  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
    timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  close() {
    this.router.navigate(['users-permissions/roles'])
  }

  ngAfterViewInit() {
    this.rolesPanels.openAll();
  }


}
